import { DatePicker } from "antd";

const BaseDatePicker = (props) => {
  return (

    <DatePicker
      style={ {
        width: '100%',
      } }
      format='YYYY-MM-DD'
      { ...props }
      placeholder={ props.placeholder }
    />

  )
}

export default BaseDatePicker
